import React, { useState } from 'react';

type NotificationData = {
  notificationData: Record<string, unknown> | undefined;
  setNotificationData: (data: Record<string, unknown> | undefined) => void;
};

export const NotificationDataContext = React.createContext<NotificationData>({
  notificationData: undefined,
  setNotificationData: () => null,
});

export const useNotificationData = () => {
  const context = React.useContext(NotificationDataContext);
  if (context === undefined) {
    throw new Error('useNotificationData must be used within a NotificationDataProvider');
  }
  return context;
};

export function NotificationDataProvider({ children }: { children: React.ReactNode }) {
  const [notificationData, setNotificationData] = useState<Record<string, unknown> | undefined>();

  return (
    <NotificationDataContext.Provider value={{ notificationData, setNotificationData }}>
      {children}
    </NotificationDataContext.Provider>
  );
}
